import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels, useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { useHistory, useLocation } from 'react-router-dom';

export const useGoToMangeGoals = () => {
  const history = useHistory();
  const { l1Module } = useRouteToNavLevels();
  const { teamType } = useRouteToMyTeamLevels();
  const location = useLocation();

  const { search } = location;

  const goToManageGoals = () => {
    const values = {
      myData: L3_PATHS['my-data'].goal.myGoals,
      team: {
        directReports: L3_PATHS.team.directReports.goal.manage,
        allReports: L3_PATHS.team.allReports.goal.manage,
        view: L3_PATHS.team.view.goal.manage,
      },
      company: L3_PATHS.company.goal.manage,
    };
    const isTeamRoute = l1Module === 'team';
    const urlToPush = isTeamRoute ? values.team[teamType] : values[l1Module];

    history.push({
      pathname: urlToPush,
      search: search.includes('viewId') ? search : '',
    });
  };

  return goToManageGoals;
};
